export default {
  undoRedo: 'undo-redo',
  reset: 'reset-button',
  undoRedoButton: 'undo-redo-button',
};
